import {
  showErrorMessage,
  showInfoMessage,
  showSuccessMessage,
  showWarningMessage,
} from "./helper-toast";

import { parseJsonString } from "./helper-string";

const handleConcludedState = (data: any): void => {
  if (data.type === "INVOICE") {
    showSuccessMessage("Invoice gerado com sucesso!");
  } else if (data.type === "FISCAL_NOTE") {
    showSuccessMessage("Nota fiscal gerada com sucesso!");
  }
};

const handleCanceledState = (data: any): void => {
  if (!data?.integrationMessage) return;

  const integrationMessage = parseJsonString(data.integrationMessage);
  showWarningMessage(
    `${integrationMessage.message}. Protocolo: ${integrationMessage.data.protocol}`,
  );
};

const handleWaitingState = (): void => {
  showWarningMessage("Documento em processamento!");
};

const handleProcessingState = (): void => {
  showInfoMessage("Em processamento... Aguarde alguns instantes!");
};

const handleFailedState = (data: any): void => {
  showErrorMessage(
    `Erro ao gerar o documento! Motivo: ${data.integrationMessage}`,
  );
};

export const handleClickInfo = async (data: any): Promise<void> => {
  switch (data.status) {
    case "CONCLUDED":
      handleConcludedState(data);
      break;
    case "CANCELED":
      handleCanceledState(data);
      break;
    case "WAITING":
      handleWaitingState();
      break;
    case "PROCESSING":
      handleProcessingState();
      break;
    case "FAILED":
      handleFailedState(data);
      break;
    default:
      console.warn("Estado desconhecido:", data.status);
      break;
  }
};
